import { Navigate, Outlet, useLocation, useSearchParams } from 'react-router';
import { FullPageLoader } from '@/components/StateViews';
import { useAuth } from '@/features/auth/auth-context';
import { safeRedirect } from './redirect';

/**
 * Signed-in users only. If the session expired, the user comes back to this
 * page after signing in again; after a deliberate sign-out they don't (the
 * next person signing in shouldn't land on the previous user's page).
 */
export function RequireAuth() {
  const { status, signOutReason } = useAuth();
  const location = useLocation();
  if (status === 'loading') return <FullPageLoader />;
  if (status === 'anonymous') {
    if (signOutReason === 'logout') return <Navigate to="/login" replace />;
    const redirect = `${location.pathname}${location.search}`;
    const to = redirect === '/' ? '/login' : `/login?redirect=${encodeURIComponent(redirect)}`;
    return <Navigate to={to} replace />;
  }
  return <Outlet />;
}

/**
 * Pages for signed-out users (login, forgot password). Once signed in, users
 * go to ?redirect= (same-app paths only) or home.
 */
export function GuestOnly() {
  const { status } = useAuth();
  const [params] = useSearchParams();
  if (status === 'loading') return <FullPageLoader />;
  if (status === 'authenticated') return <Navigate to={safeRedirect(params.get('redirect'))} replace />;
  return <Outlet />;
}
